<div class="container single-view" id="welcome">
  <div class="row">
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 class="section-title">{{ 'WELCOME.TITLE' | translate }}</h1>
        </div>
      </div>

      <hr role="presentation" class="w-full mb-3 mt-4 border-t">

      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 welcome-content">
            @if (session.user?.username) {
              <h2 class="mb-3">{{ 'WELCOME.SIGNED_IN_AS' | translate }} {{ session.user.username }}</h2>
            }
            <p class="welcome-message">{{ 'WELCOME.DESCRIPTION' | translate }}</p>
          </div>
          <!--
          <div class="flex flex-col col-12 mt-6 items-center">
            @if (allowCreateSales) {
              <button
                type="button"
                class="btn primary-btn"
                data-testid="sales-btn"
                (click)="goToSales()">
                {{ 'WELCOME.GO_TO_SALES' | translate }}
              </button>
            }
          </div>
          -->
        <div class="flex flex-col col-12 mt-6 items-center">
          @if (allowActivateWarranty) {
            <button type="button" class="btn primary-btn" data-testid="warranties-btn" (click)="goToWarranties()">{{ 'WELCOME.GO_TO_WARRANTIES' | translate }}</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>
